import styled from "styled-components";


interface IBubbleTooltipTriggerWrapperBoxProps {
    gap?: string;
}

export const InfoBubbleTooltipTriggerWrapperBox = styled.div <IBubbleTooltipTriggerWrapperBoxProps> ` 
    display: flex;
    align-items: center;
    gap: ${({ gap }) => gap ? gap : '15px'};

    font-size: 14px;
`;